import { Accordion } from 'react-bootstrap';


//tabs images
/*
import backIcon from './icons/back.png';
import kneeIcon from './icons/knee.png';
import crampsIcon from './icons/cramps.png';
import sleepIcon from './icons/sleep.png';
import headacheIcon from './icons/headaches.png';

*/
//images
import sinusImg  from './images/sinuses.png';
import nervesImg  from './images/nervepain.png';
import carpelImg  from './images/carpeltunnel.png';
import coldfluImg  from './images/coldflu.png';
import hotflashesImg  from './images/hotflashes.png';
import crampsImg  from './images/cramps.png';
import migrainesImg  from './images/migraines.png';
import sleepImg  from './images/sleep.png';
import sciaticaImg  from './images/hipsciatica.png';
import kneeImg  from './images/knee.png';
import backImg  from './images/back.png';
import shoulderImg from './images/shoulder.png';

function Legend() {
	return (
	<>
		<p style={{'font-size': '12px', 'text-align': 'left', float: 'right'}}>
            <table>
             <tr>
              <td><span className='dotBlue'></span></td><td>Is the default position for any upper and lower ailements.</td>
             </tr>
             <tr>
              <td><span className='dotGreen'></span></td><td>For the specific area.</td>
             </tr>
            </table>
		</p>
	</>
	);
}


export default function UsesTabs() {

  return (
  	<>
    <Accordion defaultActiveKey="0" className='ssAccordion'>
      <Accordion.Item eventKey="0">
        <Accordion.Header>Sinus</Accordion.Header>
        <Accordion.Body className='text-center w-100'>
            <Legend style={{float: 'right'}}/>
            <img src={sinusImg} alt='Sinuses' className='w-75' style={{margin: '0 auto'}}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header>Nerve Pain</Accordion.Header>
        <Accordion.Body className='text-center w-100'>
            <Legend style={{float: 'right'}}/>
            <img src={nervesImg} alt='Nerve Pain' className='w-75' style={{margin: '0 auto'}}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="2">
        <Accordion.Header>Carpel Tunnel, Hands</Accordion.Header>
        <Accordion.Body className='text-center w-100'>
            <Legend style={{float: 'right'}}/>
            <img src={carpelImg} alt='Carpel Tunnel' className='w-75' style={{margin: '0 auto'}}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="3">
        <Accordion.Header>Cold, Flu, Virus, Cough</Accordion.Header>
        <Accordion.Body className='text-center w-100'>
            <Legend style={{float: 'right'}}/>
            <img src={coldfluImg} alt='Cold Flu' className='w-75' style={{margin: '0 auto'}}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="4">
        <Accordion.Header>Hot Flashes</Accordion.Header>
        <Accordion.Body className='text-center w-100'>
            <Legend style={{float: 'right'}}/>
            <img src={hotflashesImg} alt='Hot Flashes' className='w-75' style={{margin: '0 auto'}}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="5">
        <Accordion.Header>Monthly Cramps</Accordion.Header>
        <Accordion.Body className='text-center w-100'>
            <Legend style={{float: 'right'}}/>
            <img src={crampsImg} alt='Monthly Cramps' className='w-75' style={{margin: '0 auto'}}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="6">
        <Accordion.Header>Migraines, Headache</Accordion.Header>
        <Accordion.Body className='text-center w-100'>
            <Legend style={{float: 'right'}}/>
            <img src={migrainesImg} alt='Migraines Headaches' className='w-75' style={{margin: '0 auto'}}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="7">
        <Accordion.Header>REM Sleep</Accordion.Header>
        <Accordion.Body className='text-center w-100'>
            <Legend style={{float: 'right'}}/>
            <img src={sleepImg} alt='REM Sleep' className='w-75' style={{margin: '0 auto'}}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="8">
        <Accordion.Header>Hip, Sciatica, Neuropathy, Foot</Accordion.Header>
        <Accordion.Body className='text-center w-100'>
            <Legend style={{float: 'right'}}/>
            <img src={sciaticaImg} alt='Hip, Sciatica, Neuropathy, Foot' className='w-75' style={{margin: '0 auto'}}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="9">
        <Accordion.Header>Knee Pain</Accordion.Header>
        <Accordion.Body className='text-center w-100'>
            <Legend style={{float: 'right'}}/>
            <img src={kneeImg} alt='Knee Pain' className='w-75' style={{margin: '0 auto'}}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="10">
        <Accordion.Header>Back Pain</Accordion.Header>
        <Accordion.Body className='text-center w-100'>
            <Legend style={{float: 'right'}}/>
            <img src={backImg} alt='Back Pain' className='w-75' style={{margin: '0 auto'}}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="11">
        <Accordion.Header>Shoulder, Neck</Accordion.Header>
        <Accordion.Body className='text-center w-100'>
            <Legend style={{float: 'right'}}/>
            <img src={shoulderImg} alt='Shoulder Neck' className='w-75' style={{margin: '0 auto'}}/>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
	</>
  );
}

